import * as React from 'react';
import clsx from 'clsx';

interface MediaStepCardProps {
  title: string;
  subtitle: string;
  badge?: string;
  error?: string | null;
  children: React.ReactNode;
  footer?: React.ReactNode;
}

/** Shared gradient card used by profile image and video avatar wizard steps. */
export const MediaStepCard: React.FC<MediaStepCardProps> = ({
  title,
  subtitle,
  badge,
  error,
  children,
  footer,
}) => (
  <div className='animate-slide-in flex w-full flex-col items-center'>
    <div
      className={clsx(
        'flex w-full max-w-[797px] flex-col',
        'rounded-20 px-10 py-[46px]',
        'shadow-[0px_4px_20px_rgba(0,0,0,0.05)]'
      )}
      style={{ background: 'linear-gradient(180deg, #EEEAFF -28.1%, #FFFFFF 63.55%)' }}
    >
      <div className='text-center'>
        <h2 className='mb-5 font-sans text-[32px] font-bold leading-[27px] text-brand-800'>
          {title}
        </h2>
        <p className='mb-5 font-sans text-18 font-normal leading-[24px] text-brand-800'>
          {subtitle}
        </p>
        {badge && <span className='font-sans text-14 text-gray-430'>{badge}</span>}
      </div>

      <div className={clsx('h-px w-full shrink-0 bg-purple-170', badge ? 'mb-10 mt-5' : 'mb-10')} />

      {error && (
        <div className='mb-6 rounded-12 border border-dashed border-red-300 bg-red-150/40 p-4 text-center font-sans text-14 text-red-550'>
          {error}
        </div>
      )}

      {children}
    </div>

    {footer && (
      <div className='mt-8 flex w-full max-w-[797px] items-center justify-end gap-4'>{footer}</div>
    )}
  </div>
);
